import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { Cards, ChipWaaper, ColumnList, ColumnTitle, ColumnWrap, EmptyHint, Header } from '../styles'
import Card from './Card'
import { CSS } from '@dnd-kit/utilities'
import { DropIndicator } from '../Helpers'

const Column = ({ column, cards, registerScrollEl, indicatorIndex, salesAdmin, update }) => {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id: column.id,
		data: { type: 'column' },
	})

	const { setNodeRef: setDroppableRef, isOver } = useDroppable({
		id: `droppable-${column.id}`,
		data: { type: 'column-drop', columnId: column.id },
	})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.35 : 1,
	}

	return (
		<ColumnWrap ref={setNodeRef} style={style}>
			<Header {...attributes} {...listeners}>
				<ColumnTitle>{column.title}</ColumnTitle>
				<ChipWaaper label={cards.length} status={column.status} />
			</Header>
			<ColumnList
				ref={(el) => {
					registerScrollEl(column.id, el)
					setDroppableRef(el)
				}}
				$isOver={isOver}
			>
				<SortableContext items={column.cardIds} strategy={verticalListSortingStrategy}>
					<Cards>
						{cards.map((c, idx) => (
							<Card key={c.id} id={c.id} data={c} showIndicatorAbove={indicatorIndex === idx} salesAdmin={salesAdmin} update={update} />
						))}
					</Cards>
				</SortableContext>

				<DropIndicator show={indicatorIndex === cards.length} />

				{cards.length === 0 && <EmptyHint>Drop cards here</EmptyHint>}
			</ColumnList>
		</ColumnWrap>
	)
}

export default React.memo(Column)
